// hooks/useComplexOrderHistory.ts
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { ComplexOrderStatus } from "../../../../common/types/enums";
import { selectComplexOrderList } from "../../../../store/slices/complexOrderListSlice";
import { getApi } from "../../../../api/api";
import { delayAction } from "../../../../common/utils/functions/delayAction";
import {
  getComplexOrderStatusColor,
  getComplexOrderStatusTextColor,
} from "../../../../common/utils/functions/enumToText";

export const useComplexOrderHistory = () => {
  const orders = useSelector(selectComplexOrderList);
  const [refreshing, setRefreshing] = useState(false);
  const api = getApi();

  const getList = useCallback(async () => {
    try {
      setRefreshing(true);
      await delayAction(1500);
      await api.getComplexOrderList();
      setRefreshing(false);
    } catch {
      setRefreshing(false);
    }
  }, [api]);

  const getOrderStatusInfo = useCallback(
    (status: ComplexOrderStatus) => {
      const statusMap: Record<
        number,
        { text: string }
      > = {
        [ComplexOrderStatus.DRAFT]: { text: "Новая" },
        [ComplexOrderStatus.SENT_TO_MANAGER]: { text: "Отправлена менеджеру" },
        [ComplexOrderStatus.IN_PROGRESS]: { text: "В работе" },
        [ComplexOrderStatus.APPROVED]: { text: "Согласована" },
        [ComplexOrderStatus.CONVERTED]: { text: "Конвертирована в заказ" },
        [ComplexOrderStatus.ARCHIVED]: { text: "Архивирована" },
      };

      const info = statusMap[status] || { text: "Неизвестно" };

      return {
        text: info.text,
        backgroundColor: getComplexOrderStatusColor(status),
        textColor: getComplexOrderStatusTextColor(status),
      };
    },
    [],
  );

  return {
    orders,
    getList,
    refreshing,
    getOrderStatusInfo,
  };
};